import React, {useEffect} from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import RoleSelector from './RoleSelector';
import GroupsSelector from './GroupsSelector';

const Step2Permissions = ({roles, onRolesChange, selectedGroups, onGroupsChange, onBack, onClose, onContinue}) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                onContinue();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onContinue]);

    return (
        <>
            <div className="flex flex-col gap-5">
                <RoleSelector
                    trainingRole={roles.trainingAndFieldRole}
                    contentRole={roles.contentCreationRole}
                    adminRole={roles.administrationRole}
                    presetName={roles.presetName}
                    onRolesChange={onRolesChange}
                />
                <GroupsSelector
                    selectedGroups={selectedGroups}
                    onGroupsChange={onGroupsChange}
                />
            </div>

            <div className="flex items-center justify-between pt-4">
                <div
                    className="flex items-center gap-1 rounded-button px-3 py-2 text-sm font-bold cursor-pointer text-main-normal hover:bg-panels-normal"
                    onClick={onBack}
                >
                    <ChevronLeftIcon style={{fontSize: 18}} />
                    Back
                </div>
                <div className="flex gap-3">
                    <div
                        className="rounded-button px-4 py-2 text-sm font-bold cursor-pointer text-main-normal hover:bg-panels-normal"
                        onClick={onClose}
                    >
                        Cancel
                    </div>
                    <div
                        data-testid="invite-step2-continue"
                        className="rounded-button px-4 py-2 text-sm font-bold flex items-center gap-1 text-classic-button-normal-text bg-classic-button-normal hover:bg-classic-button-hover cursor-pointer"
                        onClick={onContinue}
                    >
                        Continue
                        <ChevronRightIcon style={{fontSize: 18}} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Step2Permissions;
